import { color } from '@my/util'
import { YStack, SimpleText, Card } from '@my/ui'
import { shadowGenerator } from '../../../../utils/commonStyles'

export const TipCard = ({ title, content }) => (
  <YStack width="100%" gap={15}>
    <SimpleText
      fontSize={14}
      fontWeight="800"
      color={color.grey}
      letterSpacing={1}
      textTransform="uppercase"
      marginBottom="$2"
    >
      Tip for Improving Cash Flow
    </SimpleText>

    <Card
      elevate
      backgroundColor="white"
      padding="$4"
      borderRadius={10}
      width="100%"
      {...shadowGenerator(0.2)}
    >
      <YStack space="$3">
        <SimpleText fontSize={17} fontWeight="700" color={color.tzaGreen}>
          {title}
        </SimpleText>
        <SimpleText fontSize={16} color={color.lightGrey}>
          {content}
        </SimpleText>
      </YStack>
    </Card>
  </YStack>
)
